import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddRepairComponent } from '@app/features/repair/add-repair/add-repair.component';

const routes: Routes = [
  { path: '', component: AddRepairComponent },
  { path: 'add', component: AddRepairComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RepairsRoutingModule { }
